import { ModeSwitcher } from '@aloft/toolkit-sui';

import { Controller, useWatch } from 'react-hook-form';

import { useZodFormContext } from '../../../../hooks/useZodForm.ts';
import { RecommendCompsFormSchema } from '../../types.ts';
import { FilterSection } from './FilterSection.tsx';

import './ValueButtonGroup.scss';

const OPTIONS = [
  { id: 'true', label: 'Yes' },
  { id: 'false', label: 'No' },
];

export const BooleanTriStateFilter = ({
  label,
  fieldName,
}: {
  label: string;
  fieldName: 'hasBasement' | 'hasPool';
}) => {
  const { control, setValue } = useZodFormContext<RecommendCompsFormSchema>();
  const value = useWatch({ control, name: `search.filters.${fieldName}` });
  const showClear = value === true || value === false;

  return (
    <FilterSection
      label={label}
      showClear={showClear}
      onClear={() => setValue(`search.filters.${fieldName}`, '', { shouldDirty: true })}
    >
      <Controller
        name={`search.filters.${fieldName}`}
        control={control}
        render={({ field }) => (
          <div className="value-button-group">
            <ModeSwitcher
              items={OPTIONS}
              value={field.value === true ? 'true' : field.value === false ? 'false' : undefined}
              onChange={(next) => field.onChange(next === 'true')}
              variant="secondary"
              size="sm"
            />
          </div>
        )}
      />
    </FilterSection>
  );
};
